import React from "react"
import { motion } from 'framer-motion'
import FilteredProfile from "./FilteredProfile"
import PlanDetails from "./PlanDetails"

const MobileHistory = () =>{
    return (
        <motion.div className="w-full h-full flex flex-col gap-2">
            <FilteredProfile/>
            <PlanDetails/>
            </motion.div>
    )
}

export default MobileHistory